<table class="table table-sm">
  <thead>
    <tr>
      <th colspan="2">Radio</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Name</td>
      <td>{{ radioChannel()?.Name }}</td>
    </tr>
    <tr>
      <td>Description</td>
      <td>{{ radioChannel()?.Description }}</td>
    </tr>
  </tbody>
</table>